<template>
  <div class="card">
    <div class="card-header px-3 py-2" id="headingRepCodes">
      <div class="card-header-title">
        <button class="btn btn-block text-left" type="button"
          data-toggle="collapse" data-target="#collapseRepCodes"
          aria-expanded="false" aria-controls="collapseRepCodes">
          <span class="font-weight-bold">RepCodes</span>
          <i class="fa fa-chevron-up ml-1"></i>
        </button>
      </div>
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary add-repcode"
        title="Add RepCode"
        v-on:click.stop="click(`add`)">
        <i class="fas fa-plus-square mr-2"></i>
        <span>Add</span>
      </button>
    </div>
    <div id="collapseRepCodes" class="collapse" aria-labelledby="headingRepCodes" data-parent="#accordionMenu">
      <div class="card-body pt-3">
        <search :o="table"></search>
        <div class="d-flex align-items-center py-2 select-all-bar">
          <input
            type="checkbox"
            class="repcode-checkbox mr-2"
            :checked="allSelected"
            :title="allSelected ? `Deselect all visible repcodes` : `Select all visible repcodes`"
            v-on:click.stop="selectAll($event.target.checked)"
          />
          <span class="text-muted" v-text="`Select All (${table.items.length})`"></span>
          <a
            v-if="selectedCount > 0"
            href="#"
            class="text-muted ml-auto p-0"
            style="font-size: 0.75rem; text-decoration: none;"
            title="Deselect all repcodes"
            v-on:click.stop="deselectAll()"
          >
            Deselect All ({{ selectedCount }})
          </a>
        </div>
        <div class="repcodes">
          <scroll-area class="pr-3">
            <table class="table table-sm">
              <tbody>
                <tr v-for="(o, i) in table.items" :key="i" class="repcode">
                  <td>
                    <input
                      type="checkbox"
                      class="repcode-checkbox mr-1"
                      :checked="isSelected(o)"
                      v-on:click.stop="toggle(o)"
                    />
                    <i
                      v-if="o.code !== null"
                      class="far fa-edit mr-1"
                      :title="title(`edit`)"
                      v-on:click="click(`edit`, o)"
                    ></i>
                    <a
                      href="#"
                      class="badge badge-light"
                      :title="getBillingTitle(o)"
                      v-on:click="click(`view`, o)"
                      v-text="o.label"
                    ></a>
                    <small class="text-muted ml-2"
                      v-text="`(${o.contractCount}/${o.invoiceCount}/${o.accountCount})`"
                      title="Contracts / Invoices / Accounts"
                    ></small>
                  </td>
                </tr>
              </tbody>
            </table>
          </scroll-area>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
div.card-header {
  display: flex;
  justify-content: space-between;
}
div.card-header-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
div.card-header i,
div.card-header span {
  opacity: 0.7;
}
.add-repcode {
  float: right;
  font-size: 0.8rem;
}
div.repcodes {
  height: 50vh;
  margin-top: 6px;
  margin-right: -15px;
  margin-bottom: -10px;
}
.select-all-bar {
  font-size: 0.85rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.select-all-bar span {
  cursor: default;
}
tr.repcode {
  font-size: 0.9rem;
}
i {
  opacity: 0.3;
}
table i:hover {
  cursor: pointer;
  opacity: 1;
}
.badge {
  font-size: 0.8rem;
}
.repcode-checkbox {
  cursor: pointer;
  vertical-align: middle;
}
</style>

<script>
import { scrollArea, search } from "../../../component";
import { Api, List, Modal } from "../../../factory";
import { alert, session } from "../../../service";

export default {
  name: `FirmRepCodes`,
  get components() {
    return {
      scrollArea,
      search,
    };
  },
  data() {
    return {
      table: ``,
    };
  },
  computed: {
    selectedCount() {
      var state = session.get(`state`);
      return Array.isArray(state.selectedRepCodes) ? state.selectedRepCodes.length : 0;
    },
    allSelected() {
      var state = session.get(`state`);
      var items = this.table.items;
      if (!items.length) return false;
      if (!Array.isArray(state.selectedRepCodes) || !state.selectedRepCodes.length) return false;
      return items.every((item) =>
        state.selectedRepCodes.some((r) => r.code === item.code)
      );
    },
  },
  watch: {
    'table.search'(val, oldVal) {
      // When search is cleared, deselect repcodes added by previous "Select All"
      if (!val && oldVal && this._selectAllAdded.length) {
        var state = session.get(`state`);
        var codes = this._selectAllAdded;
        state.selectedRepCodes = state.selectedRepCodes.filter(
          (r) => !codes.some((c) => c === r.code)
        );
        this._selectAllAdded = [];
        this._syncRepCode(state);
      }
    },
  },
  created() {
    this._selectAllAdded = [];
    this.init();
  },
  methods: {
    init() {
      var state = session.get(`state`);
      var table = {
        async _load() {
          try {
            this.ready = false;
            var { data } = await Api.get(`repcodes`);
            this._data = Array.isArray(data) ? data : [];
            this.ready = true;
          } catch (e) {
            console.error(e);
            alert.error(e.message);
            this.ready = true;
          }
        },
        init() {
          this._data = [];
          this.ready = false;
          this.search = ``;
          this._load();
          return this;
        },
        get items() {
          return List.filter(Array.from(this._data), this.search);
        },
      };
      this.table = table.init();
      if (!state.hasOwnProperty(`selectedRepCodes`)) {
        this.$set(state, `selectedRepCodes`, []);
      }
    },
    _syncRepCode(state) {
      if (state.selectedRepCodes.length === 1) {
        state.repCode = state.selectedRepCodes[0];
      } else if (state.selectedRepCodes.length === 0) {
        state.repCode = { code: 'UNASSIGNED', label: 'Unassigned' };
      } else {
        state.repCode = { _multi: true, codes: state.selectedRepCodes };
      }
      state.custodian = ``;
    },
    toggle(o) {
      var state = session.get(`state`);
      if (!Array.isArray(state.selectedRepCodes)) {
        this.$set(state, `selectedRepCodes`, []);
      }
      var idx = state.selectedRepCodes.findIndex((r) => r.code === o.code);
      if (idx >= 0) {
        state.selectedRepCodes.splice(idx, 1);
      } else {
        state.selectedRepCodes.push(o);
      }
      this._syncRepCode(state);
    },
    selectAll(checked) {
      var state = session.get(`state`);
      if (!Array.isArray(state.selectedRepCodes)) {
        this.$set(state, `selectedRepCodes`, []);
      }
      var items = this.table.items;
      if (checked) {
        // Track which codes we add so they can be auto-deselected when search clears
        this._selectAllAdded = [];
        for (var item of items) {
          if (!state.selectedRepCodes.some((r) => r.code === item.code)) {
            state.selectedRepCodes.push(item);
            this._selectAllAdded.push(item.code);
          }
        }
      } else {
        // Remove all visible items from selection
        state.selectedRepCodes = state.selectedRepCodes.filter(
          (r) => !items.some((item) => item.code === r.code)
        );
        this._selectAllAdded = this._selectAllAdded.filter(
          (c) => !items.some((item) => item.code === c)
        );
      }
      this._syncRepCode(state);
    },
    deselectAll() {
      var state = session.get(`state`);
      state.selectedRepCodes = [];
      this._selectAllAdded = [];
      this._syncRepCode(state);
    },
    isSelected(o) {
      var state = session.get(`state`);
      // "No RepCode" is implicitly selected when nothing is explicitly selected
      if (o.code === null && (!Array.isArray(state.selectedRepCodes) || state.selectedRepCodes.length === 0)) 
        return true;
      
      return Array.isArray(state.selectedRepCodes) &&
        state.selectedRepCodes.some((r) => r.code === o.code);
    },
    click(type, d) {
      var state = session.get(`state`);
      switch (type) {
        case `add`:
          return Modal.open(`repcode-billing`, {
            repcode: null,
            methods: {
              success: () => {
                this.table._load();
                Modal.close();
              },
            },
          });
        case `view`:
          // Single-click: set single view and clear multi-select
          state.selectedRepCodes = [d];
          state.repCode = d;
          state.custodian = ``;
          return;
        case `edit`:
          return Modal.open(`repcode-billing`, {
            repcode: d,
            methods: {
              success: () => {
                this.table._load();
                Modal.close();
              },
            },
          });
        default:
          throw new Error(`Invalid click type, ${type}!`);
      }
    },
    title(type) {
      switch (type) {
        case `add`:
          return `Add RepCode`;
        case `view`:
          return `View RepCode`;
        case `edit`:
          return `Edit RepCode billing defaults`;
        default:
          return ``;
      }
    },
    getBillingTitle(o) {
      var billing = o.billing;
      if (billing && billing.schedule && billing.type && billing.values) {
        const typeDisplay = billing.type.charAt(0).toUpperCase() + billing.type.slice(1);
        return `${billing.schedule} ${typeDisplay}, ${billing.values}`;
      }
      return this.title(`view`);
    },
  },
};
</script>
